import { Helmet, HelmetProvider } from 'react-helmet-async';

interface HelmetConfigProps {
  children: React.ReactNode;
}

const HelmetConfig: React.FC<HelmetConfigProps> = ({ children }) => (
  <HelmetProvider>
    <Helmet>
      <meta charSet="utf-8" />
      <title>OyaSync</title>

      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link
        href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500&family=Newsreader:opsz,wght@6..72,500&family=Playfair+Display:wght@700&display=swap"
        rel="stylesheet"
      />
    </Helmet>
    {children}
  </HelmetProvider>
);

export default HelmetConfig;
